import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router';
import { ItemWithImage } from '../../../components/imageLink/ItemWIthImage';
import { technology } from '../../../config/technology';
import { progressImageConfig } from './progressImageConfig';
import './ProgressNav.css';


export function ProgressNav(props: {}) {
    const { spec } = useParams<{ spec: string }>();
    const jsxs: JSX.Element[] = [];
    const specActive: { [key: string]: string } = (technology as any)[spec];

    if (JSON.stringify(specActive) === '{}') {
        jsxs.push(<span style={{ fontSize: 18, padding: '20px' }}>算法完善中</span>);
    } else {
        for (let key in specActive) {
            // 判断是否为当前激活项（示例：可根据路由匹配调整）
            const isActive = window.location.pathname.includes(key);

            jsxs.push(
                <div
                    style={{
                        // 布局：每个项独立容器，居中对齐
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 15px', // 项之间的间距
                        color: '#424242',
                        fontSize: 16,
                        fontWeight: 600
                    }}
                >
                    {/* 图片容器：圆形/椭圆 + 白色背景 + 边框（图二的容器样式） */}
                    <div
                        style={{
                            width: 140, // 图片容器宽度（图二更小）
                            height: 140, // 图片容器高度
                            borderRadius: '50%', // 圆形（图二是圆形容器）
                            background: '#f6f6f6', // 容器背景色（图二为白色）
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)', // 轻微阴影（图二质感）
                            border: isActive ? '2px solid #40a9ff' : 'none', // 激活项加边框（可选）
                            marginBottom: 10
                        }}
                    >
                        <ItemWithImage
                            src={(progressImageConfig as any)[spec][key]}
                            to={`/${key}`}
                            key={key}
                           
                        />
                    </div>

                    {/* 文字样式：图二的文字更小、居中 */}
                    <FormattedMessage
                        id={key}
                        description={key}
                        defaultMessage={key}
                      
                    />
                </div>
            );
        }
    }

    return (
        <div
            style={{
                width: '100%',
                // height: '90%',
                background: '#fff',
                padding: '20px', // 内边距调整
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                borderRadius: '8px',
                position: 'relative',
                zIndex: '1',
            }}
        >
            {/* 布局：横向排列 + 自动换行 */}
            <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap', // 超出换行
                    alignItems: 'center',
                    gap: '50px', // 项之间的间距
                    paddingLeft: 60,
                    // paddingRight: 90
                }}
            >
                {jsxs}
            </div>
        </div>
    );
}